import { getBidderEmail } from '@/redux/modules/account/user/user.selectors';
import { useAppSelector } from '@/redux/hooks';
import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import ConfirmModal from '@liveauctioneers/caterwaul-components/lib/SimpleModal/ConfirmModal/ConfirmModal';
import React from 'react';

export type TwoStepAuthenticationActivationModalProps = {
    onActivate: () => void;
    onCancel: () => void;
    show: boolean;
};

const TwoStepAuthenticationActivationModal = ({
    onActivate,
    onCancel,
    show,
}: TwoStepAuthenticationActivationModalProps) => {
    const { formatMessage } = useIntl();
    const email = useAppSelector(getBidderEmail);

    return (
        <ConfirmModal
            confirmText={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.activationModal.activate',
            })}
            onConfirm={onActivate}
            onDismiss={onCancel}
            show={show}
            testid="TwoStepAuthenticationActivationModal"
            title={formatMessage({
                id: 'accountSettings.security.twoStepAuthentication.activationModal.header',
            })}
            warning={formatMessage(
                {
                    id: 'accountSettings.security.twoStepAuthentication.activationModal.description',
                },
                { email }
            )}
        />
    );
};

export default TwoStepAuthenticationActivationModal;
